module.exports = __webpack_public_path__ + "static/media/lfsa.5a675f3e.png";